<template>
  <span class="c-counter" :class="`c-counter-${props.theme}`">
    <span><slot>{{ count }}</slot></span>
  </span>
</template>

<script setup lang="ts">
  export type Theme = 'neutral'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'contrast';

  const props = withDefaults(defineProps<{
    theme?: Theme;
    count?: number,
  }>(), {
    theme: 'neutral',
    count: 0,
  });
</script>

<style lang="scss">
  .c-counter {
    $size: 1.5rem;

    height: $size;
    min-width: $size;
    display: inline-grid;
    place-items: center;
    padding: 0 .5rem;
    border-radius: #{$size*.5};
    font-size: .875rem;
    font-weight: $font-weight-medium;

    &-neutral {
      background-color: $neutral-400;
      color: $neutral-900;
    }

    &-info {
      background: $info;
      color: $neutral-0;
    }

    &-success {
      background: $success;
      color: $neutral-900;
    }

    &-warning {
      background: $warning;
      color: $neutral-900;
    }

    &-danger {
      background-color: $danger;
      color: $neutral-0;
    }

    &-contrast {
      background: $neutral-1000;
      color: $neutral-0;
    }
  }
</style>
